function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "746FEAE9-C32F-403D-A6D2-A2EC7E5A9BE9");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter-1"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  type: "matrix",
  values: "0 0 0 0 0.250980 0 0 0 0 0.701961 0 0 0 0 0.858824 0 0 0 1.000000 0"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "DMA-Summary",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Asset-Summary-3",
  transform: "translate(-792.000000, -286.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Asset-Summary",
  transform: "translate(324.000000, 213.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon/home",
  transform: "translate(453.000000, 63.000000)",
  filter: "url(#filter-1)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(15.000000, 10.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 0,
  y: 0,
  width: 20,
  height: 20
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.2513076,10.9368791 C17.3652942,10.9368791 17.5196029,10.8671847 17.5957542,10.7813256 L18.2149669,10.0834666 C18.2802959,10.0097382 18.3333333,9.86949117 18.3333333,9.77044279 C18.3333333,9.65500079 18.2644723,9.4987607 18.1796745,9.42165632 L16.4814878,7.90320062 L16.4814878,3.90564583 C16.4814878,3.64689554 16.2740851,3.43689695 16.0185334,3.43689695 L14.1667161,3.43689695 C13.9111644,3.43689695 13.7037618,3.64689554 13.7037618,3.90564583 L13.7037618,5.42001028 L10.7741289,2.80143666 C10.5923549,2.63503996 10.2459021,2.5 10.0008618,2.5 C9.75579329,2.5 9.40936872,2.63503996 9.22756647,2.80143666 L1.8202972,9.42251462 C1.73549948,9.49964762 1.66666667,9.65588771 1.66666667,9.7713011 C1.66666667,9.87049253 1.71981712,10.010854 1.78528741,10.0846396 L2.40478269,10.7816117 C2.48093393,10.8674708 2.63527088,10.9371652 2.7492293,10.9371652 C2.84719455,10.9371652 2.98584915,10.8833495 3.05869438,10.8170597 L9.69399634,4.89089396 C9.76644598,4.82617777 9.9036595,4.77364952 10.0002684,4.77364952 C10.0968774,4.77364952 10.2340909,4.82617777 10.3065405,4.89089396 L16.9418425,10.8167736 C17.0146877,10.8830634 17.1533423,10.9368791 17.2513076,10.9368791 Z M7.68535551,17.4993634 C7.9409072,17.4993634 8.14830984,17.2893648 8.14830984,17.0306145 L8.14830984,13.2806235 C8.14830984,13.0218732 8.35571247,12.8118746 8.61126417,12.8118746 L11.3889901,12.8118746 C11.6445418,12.8118746 11.8519445,13.0218732 11.8519445,13.2806235 L11.8519445,17.0306145 C11.8519445,17.2893648 12.0593471,17.4993634 12.3148988,17.4993634 L16.0185334,17.4993634 C16.2740851,17.4993634 16.4814878,17.2893648 16.4814878,17.0306145 L16.4814878,11.6136238 C16.4322932,11.5796636 16.3738588,11.5603231 16.3292983,11.5198969 L10.0001272,5.86853178 L3.67703115,11.514318 C3.63015363,11.5570901 3.57027813,11.5770028 3.51876655,11.6124508 L3.51876655,17.0306145 C3.51876655,17.2893648 3.72616918,17.4993634 3.98172088,17.4993634 L7.68535551,17.4993634 Z",
  id: "home",
  fill: "#F6F7F7",
  fillRule: "nonzero"
}))))));

var SvgIconHome = function SvgIconHome(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconHome, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Icon_home.aede39de.svg";
export { ForwardRef as ReactComponent };